<template>
  <b-modal ref="addItemModal"
           id="modal-add-contact"
           title="Добавить контакт"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите Имя"
                        v-model="addForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-phone">
        <b-form-input id="phone"
                        type="tel"
                        placeholder="Введите телефон"
                        v-model="addForm.phone"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-email">
        <b-form-input id="email"
                        type="email"
                        placeholder="Введите почту"
                        v-model="addForm.email"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-title">
        <b-form-input id="title"
                        type="text"
                        placeholder="Введите должность"
                        v-model="addForm.title"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-questions">
        <b-form-input id="questions"
                        type="text"
                        placeholder="Введите вопросы"
                        v-model="addForm.questions"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-sort">
        <b-form-input id="sort"
                        type="number"
                        placeholder="Введите порядок (больше — выше)"
                        v-model="addForm.sort"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-pic">
        <picture-input ref="pictureInput" width="200" height="200" margin="8" accept="image/jpeg,image/png" size="10"
          :removable="true" :customStrings="{
          upload: '<h1>Перетащите изображение</h1>',
          drag: 'Перетащите изображение',
          change: 'Заменить фото',
          remove: 'Удалить фото',
        }">
        </picture-input>
      </b-form-group>
      <b-form-group id="form-title-group-group" label="Группа">
        <b-form-select id="group"
                        type="text"
                        placeholder="Группа пользователей"
                        v-model="addForm.group"
                        :options="groups"
                        required>

        </b-form-select>
      </b-form-group>
      <b-button type="submit" variant="success">Добавить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';
import PictureInput from 'vue-picture-input';

export default {
  components: {
    alertMsg,
    PictureInput,
  },
  name: 'modalAdd',
  data() {
    return {
      addForm: {
        email: '',
        questions: '',
        name: '',
        phone: '',
        title: '',
        group: '',
        photo: '',
        file: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      groups: [],
    };
  },
  computed: {
    ...mapState({
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    addItem(payload) {
      this.showAlert = false;
      const id = 'modal-add-contact';
      const path = this.host + 'add_contact';
      axios.post(path, payload, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('contacts');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
            this.initForm();
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    take_groups() {
      this.showAlert = false;
      const path = this.host + 'take_contact_groups';
      axios.post(path, {}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.groups = res.data.groups;
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = {
        'email' : this.addForm.email,
        'name' : this.addForm.name,
        'phone' : this.addForm.phone,
        'questions' : this.addForm.questions,
        'group' : this.addForm.group,
        'title' : this.addForm.title,
        'sort' : this.addForm.sort,
        'photo' : this.$refs.pictureInput.image,
        'photo_name' : this.$refs.pictureInput.file.name,
      };
      this.addItem(payload);
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-add');
      this.initForm();
    },
    initForm() {
      this.addForm.email = '';
      this.addForm.password = '';
      this.addForm.name = '';
      this.addForm.title = '';
      this.addForm.questions = '';
      this.addForm.phone = '';
      this.addForm.photo = '';
      this.addForm.sort = '';
    },
  },
  created() {
    this.take_groups();
  },
};
</script>

<style scoped>

</style>
